import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { Calculator } from 'lucide-react';

export default function RoiCalculator() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 pt-32 pb-20">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="w-20 h-20 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-8">
            <Calculator className="text-primary" size={36} />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            ROI Calculator
          </h1>
          <p className="text-xl text-slate-600 mb-12 max-w-xl mx-auto">
            Our ROI Calculator is available on the homepage. Tell us about your operation and get a custom estimate — free, no strings attached.
          </p>
          <Link
            to="/#roi"
            className="inline-flex items-center gap-2 bg-primary text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-primary-dark transition-colors shadow-lg hover:shadow-xl"
          >
            Go to ROI Calculator
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
